<template>
    <button
        class="button-dialog cursor-pointer"
        type="button"
        :class="buttonClasses"
        :disabled="buttonDisabled"
        @click="toggleDialog()"
    >
        <span class="flex flex-row space-x-2 items-center">
            <span v-if="buttonIcon">
                <component :is="iconComponent" :size="5" :marginAuto="false"></component>
            </span>
            <span>{{ buttonText }}</span>
        </span>
    </button>
    <layout-dialog v-if="dialog" :title="dialogTitle">
        <template v-slot:content>
            <component v-if="dialogContent" :is="dialogContent" @closed="closeDialog"></component>
        </template>
    </layout-dialog>
</template>

<script>
export default {
    name: 'ButtonDialog',
    emits: ['closed'],
    props: {
        dialogTitle: {
            required: false,
            type: String,
            default: null,
        },
        dialogContent: {
            required: false,
            type: String,
            default: null,
        },
        buttonColor: {
            required: false,
            type: String,
            default: 'bg-purple-600 text-white hover:bg-purple-500 focus-visible:outline-zinc-600',
        },
        buttonDisabled: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        buttonText: {
            required: false,
            type: String,
            default: null,
        },
        buttonIcon: {
            required: false,
            type: String,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
        };
    },
    computed: {
        iconComponent() {
            return 'icon-' + this.buttonIcon;
        },
        buttonClasses() {
            const cls = {};
            cls['inline-block'] = true;
            cls['px-3 sm:px-4 py-3'] = true;
            cls['rounded-md shadow-xs'] = true;
            cls['cursor-pointer'] = true;
            cls['focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2'] = true;
            cls['sm:text-lg font-bold'] = true;
            cls[this.buttonColor] = true;
            cls['disabled:bg-zinc-500'] = !!this.buttonDisabled;
            return cls;
        },
    },
    methods: {
        toggleDialog() {
            this.dialog = !this.dialog;
        },
        closeDialog() {
            console.log('Closing dialog.');
            this.$emit('closed');
            this.dialog = false;
        },
    },
};
</script>
